import { render, staticRenderFns } from "./oomSlider.vue?vue&type=template&id=18da4637&scoped=true"
import script from "./oomSlider.vue?vue&type=script&lang=js"
export * from "./oomSlider.vue?vue&type=script&lang=js"
import style0 from "./oomSlider.vue?vue&type=style&index=0&id=18da4637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da4637",
  null
  
)

export default component.exports